import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';

import heroImage from './img/hero-img.avif';
import css from './CreatorsPage.module.css';

const SectionHero = () => {
  return (
    <div className={css.heroContainer}>
      <div className={css.heroContent}>
        <div className={css.heroTitleContainer}>
          <h1 className={css.heroTitle}>
            <FormattedMessage id="CreatorsPage.heroTitle" />
          </h1>
          <NamedLink className={css.heroButton} name="RoleSelectionPage">
            <FormattedMessage id="CreatorsPage.heroButton" />
          </NamedLink>
        </div>
        <img className={css.heroImage} src={heroImage} alt="Start attracting" />
      </div>
    </div>
  );
};

export default SectionHero;
